module.exports = __webpack_public_path__ + "static/img/MANCHESTER-MDF.fa4e532.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/MANCHESTER-MDF.png
// module id = 1avk
// module chunks = 0